import { render } from "./OrderTile.vue?vue&type=template&id=2cd0cba4&scoped=true"
import script from "./OrderTile.vue?vue&type=script&lang=js"
export * from "./OrderTile.vue?vue&type=script&lang=js"

import "./OrderTile.vue?vue&type=style&index=0&id=2cd0cba4&scoped=true&lang=css"

import exportComponent from "/Users/felix/dev/projects/protfolio/schillerando-demo/schillerando-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd0cba4"]])

export default __exports__